<template>
<div id='main' style="width: 100%;">
	<el-header style="height:62px;">
	<div class="header-logo-box">
		   <img src="../assets/images/logo.png" class="header-logo">	
		   
		   <el-row>
		     <el-col class="tool" :span="24">
		   	  
		   	  <ul class="toolbar" id="row-bar-group">
		   
		   	            <li :class="{'active': editMode==1&&this.recordTemp.step>1}" v-on:click='back()' class="icon-font">
		   	                <span class="nav-bg-img nav-img-back"></span>
		   	                <span class="icon-text">后退</span>
		   	            </li>
		   	            <li :class="{'active': editMode==1&&this.recordTemp.k>this.recordTemp.step}" v-on:click='forward()' class="icon-font">
		   	                <span class="nav-bg-img nav-img-forword"></span>
		   	                <span class="icon-text">前进</span>
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div v-on:click='preProcessing()'>	
		   						<span class="nav-bg-img nav-img-preprocessing"></span>
		   						<span  class="icon-text">预处理</span>
		   					</div>
		   	            </li>						
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div v-on:click='alignerLine()'>	
		   						<span class="nav-bg-img nav-img-alignment"></span>
		   						<span  class="icon-text">对齐</span>
		   					</div>
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div v-on:click='esplitLine()'> 
		   						<span class="nav-bg-img nav-img-split"></span>
		   						<span class="icon-text">拆分</span>
		   					</div>
		   	               
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div v-on:click='mergeLine()'>
		   						<span class="nav-bg-img nav-img-merge"></span>
		   						<span class="icon-text">合并</span>
		   					</div>
		   	           
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div v-on:click='moveUp()'>
		   						<span class="nav-bg-img nav-img-up"></span>
		   						<span class="icon-text">上移</span>
		   					</div>
		   	            </li>
		   	            <li  :class="{'active': editMode==1}" class="icon-font">
		   					<div v-on:click='moveDown()' >
		   					<span class="nav-bg-img nav-img-down"></span>
		   					<span class="icon-text">下移</span>	
		   					</div>
		   	            </li>
		   	            
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div  v-on:click='editorAdd()'>
		   						<span class="nav-bg-img nav-img-insert"></span>
		   						<span class="icon-text">插入</span>
		   					</div>
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div v-on:click='editorDelete()'>
		   						<span class="nav-bg-img nav-img-delete"></span>
		   						<span class="icon-text">删除</span>
		   					</div>
		   	               
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div v-on:click='changeLine()'>
		   						
		   						<span class="nav-bg-img nav-img-swop"></span>
		   						<span class="icon-text">调换</span>
		   					</div>
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div  v-on:click='changeAll()'>
		   					<span class="nav-bg-img nav-img-extract"></span>
		   					<span class="icon-text">全文调换</span>	
		   					</div>
		   
		   	            </li>
		   	     
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div  data-toggle="modal" data-target="#search-modal">
		   						<span class="nav-bg-img nav-img-search"></span>
		   						<span class="icon-text">查找</span>
		   					</div>
		   
		   	            </li>
		   	  
		   	            <li :class="{'active': editMode==1}" class="icon-font" >
		   					<div  v-on:click="repeatFindAll(1)">		
		   						<span class="nav-bg-img nav-img-qc"></span>
		   						<span class="icon-text">同文去重</span>
		   						
		   					</div>
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="icon-font" >
		   					<div v-on:click="repeatFindAll(2)">
		   						<span class="nav-bg-img nav-img-qc2"></span>
		   						<span class="icon-text">多译去重</span>
		   					</div>
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div>
		   						<span class="nav-bg-img nav-img-sy"></span>
		   						<span class="icon-text">术语</span>
		   					</div>
		   
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="icon-font">	
		   					<div v-on:click='countWords()'>
		   						<span class="nav-bg-img nav-img-count"></span>
		   						<span class="icon-text">字数</span>	
		   					</div>
		   
		   	            </li>
		   
		   	            <li :class="{'active': editMode==1}" class="one icon-font">
		   					<div v-on:click='exportFile()'>
		   						<span class="nav-bg-img nav-img-export"></span>
		   						<span class="icon-text">导出</span>	
		   					</div>
		   
		   	            </li>
		   	            <li :class="{'active': editMode==1}" class="one icon-font">
		   					<div v-on:click='saveTmx()'>
		   						<span class="nav-bg-img nav-img-export"></span>
		   						<span class="icon-text">保存</span>
		   					</div>
		   
		   	            </li>
		   				<li :class="{'active': editMode==1}" class="one icon-font">
		   					<div v-on:click='removeAll()()'>
		   						<span class="nav-bg-img nav-img-export"></span>
		   						<span class="icon-text">重置</span>
		   					</div>
		   				
		   				</li>
		   	            <li :class="{'active': editMode==1}" class="icon-font">
		   					<div>
		   						<span class="nav-bg-img nav-img-help"></span>
		   						<span class="icon-text">帮助</span>
		   					</div>
		   
		   	            </li>
		   	       
		   	  
		   	      </ul>
		   	  </el-col>
		   </el-row>
	</div>
	</el-header>
<el-main>
<div class="container">
	
	<el-row  v-if='uploadType!==0' class="lan-switch">
	  <el-col :span="12" :offset="6"  class="lan-switch-group">
		  		<el-input size='small' v-model="info.title" placeholder="标题"></el-input>
		          <a href="javascript:void(0);"  v-on:click='switchMode(1)' :class="{'chang-active':uploadType==1}">双语单文档</a>
		          <a href="javascript:void(0);" v-on:click='switchMode(2)' :class="{'chang-active':uploadType==2}">单语双文档</a>
		      <span>(支持txt,xlsx,docx,pptx,pdf,tmx)</span>
		      
		  
		</el-col>
	</el-row>
	
	
	<el-row>
	  <el-col class="list-box" :span="24">

	
	            <div class="table-box">
	                <table class="table-header">
	        
	
	           <thead>
	                    <tr>
	                        <td class="serial-number"></td> 
	                        <td v-if="uploadType==1" class="select-td" colspan="2" >
							<el-col :span="11">
	                            <el-col :span="12" style="width:200px;float: left;">
	                                语言：
									 <el-select  size='small' v-model="selectLang.origin" @change="initLang('origin')" placeholder="请选择">
										 <el-option  v-for="(l,index) in lang" :key="index"  :label="l.title" :value='l.code'></el-option>	  
									  </el-select>
	                      
	                            </el-col>
				
								</el-col>
								<el-col :span="8" >
									<el-upload
									  class="upload"
									  :action="urlUpload"
									  :on-success="handleSuccess"
									  :before-upload="handleBefore"
									  :data="tokenUpload"
									  accept=".txt,.xls,.xlsx,.docx,.doc,.pptx,.pdf,.tmx"
									  :file-list="fileList">
									  <el-button v-on:click="changeUploadType('normal')" size="small" type="primary">点击上传</el-button>
									</el-upload>
							
								</el-col>
							<el-col :span="5" >
	                            <el-col :span="12"  style="width:200px; float:right;" >
	                                语言：
	                   
								  <el-select  size='small' v-model="selectLang.translate" @change="initLang('translate')" placeholder="请选择">
								  	<el-option  v-for="(l,index) in lang" :key="index"  :label="l.title" :value='l.code'></el-option>	  
								   </el-select>
								  	                              
	                            </el-col>
						
							</el-col>
	             
	                        </td>     
	                        <td v-if="uploadType==2" class="select-td" colspan="2" >
	                        <el-col :span="12">
	                            <el-col :span="12" style="width:200px;">
	                                语言：
	                        		 <el-select  size='small' v-model="selectLang.origin" @change="initLang('origin')" placeholder="请选择">
	                        			 <el-option  v-for="(l,index) in lang" :key="index" :label="l.title" :value='l.code'></el-option>	  
	                        		  </el-select>
	                        	                      
	                            </el-col>
	                        	<el-col :span="12">
	                        		<el-upload
	                        		  class="upload"
	                        		  :action="urlUpload"
	                        		  :on-success="handleSuccess"
	                        		  :before-upload="handleBefore"
	                        		  :data="tokenUpload"
	                        		  :file-list="fileList">
	                        		  <el-button v-on:click="changeUploadType('origin')" size="small" type="primary">点击上传</el-button>
	                        		</el-upload>
	                        								
	                        	</el-col>
	                        	</el-col>
	                 
	                        <el-col :span="12" >
	                            <el-col :span="12" style="width:200px;" >
	                                语言：
	                        	                   
	                        	  <el-select  size='small' v-model="selectLang.translate" @change="initLang('translate')" placeholder="请选择">
	                        	  	<el-option  v-for="(l,index) in lang" :key="index"  :label="l.title" :value='l.code'></el-option>	  
	                        	   </el-select>
	                        	  	                              
	                            </el-col>
	                        	<el-col :span="12">
	                        		<el-upload
	                        		  class="upload"
	                        		  :action="urlUpload"
	                        		  :on-success="handleSuccess"
	                        		  :before-upload="handleBefore"
	                        		  :data="tokenUpload"
	                        		  :file-list="fileList">
	                        		  <el-button v-on:click="changeUploadType('translate')" size="small" type="primary">点击上传</el-button>
	                        		</el-upload>
	                        								
	                        	</el-col>
	                        </el-col>
	                        	             
	                        </td>  
	                    </tr>
	                    <tr>
	                        <td class="serial-number">序号</td>
	                        <td class="source-lang">源语言</td>
	                        <td class="source-lang">目标语言</td>
	                    </tr>
	                </thead>
	         
	           
	           <!--thead v-else-if="uploadType==3" >
	                    <tr>
	                        <td class="serial-number"></td> 
	                        <td colspan="2" style="padding: 0 10px;">
	                            <div style="display: inline-block;float: left;">
	                                
	                              <select v-model='selectLang.origin' class="form-inline" @change="initLang('origin')">
	                              <option  v-for="(l,index) in lang" :key="index" :value='l.code'>{{l.title}}</option>	  
	                               </select>
	                   
	                            </div>
	                            <div style="display: inline-block;float: right;">
	                                语言：
	                               
	                             <select v-model='selectLang.translate' class="form-inline" @change="initLang('translate')">
	                             <option  v-for="(l,index) in lang" :key="index" :value='l.code'>{{l.title}}</option>	  
	                              </select>
	                            </div>
	      
	                        </td>     
	                        
	                    </tr>
	                    <tr>
	                        <td class="serial-number">序号</td>
	                        <td class="source-lang">源语言</td>
	                        <td class="source-lang">目标语言</td>
	                    </tr>
			
	                </thead-->
					<tbody>
						
							 
						<tr v-for="(k,index) in info.lineList" :key="k">
										
						    <td  v-on:click="editorClick(k,'b',$event)"  class="serial-number">{{k+1}}</td>
						    <td class="origin content-col source-lang" v-on:click="editorClick(k,'origin',$event)" v-on:dblclick="editorDbClick(k,'origin',$event)" :class="{'clicked':nodes['origin'][k]&&nodes['origin'][k]['clicked'],'forbidden':info.origin.content[k]==undefined}">
						          <div v-if="!nodes['origin'][k]||nodes['origin'][k]&&!nodes['origin'][k]['dbclicked']">{{info.origin.content[k]}}</div>   
						    <el-input  v-if="nodes['origin'][k]&&nodes['origin'][k]['dbclicked']" class='text_editor' type="textarea"  :autosize="{}"
								@input="textareaChange($event)"  v-model="info.origin.content[k]">
						    </el-input>
							
							</td>
						    <td class="translate content-col source-lang" v-on:click="editorClick(k,'translate',$event)" v-on:dblclick="editorDbClick(k,'translate',$event)" :class="{'clicked':nodes['translate'][k]&&nodes['translate'][k]['clicked'],'forbidden':info.translate.content[k]==undefined}">
						            
						        <div v-if="!nodes['translate'][k]||nodes['translate'][k]&&!nodes['translate'][k]['dbclicked']">{{info.translate.content[k]}}</div>
						        
								
								 <el-input v-if="nodes['translate'][k]&&nodes['translate'][k]['dbclicked']" class='text_editor' type="textarea"  :autosize="{}"
						        	@input="textareaChange($event)"  v-model="info.translate.content[k]">
						        </el-input>
									
						    </td>
						</tr>
						<tr>
						    <td colspan="3">
						    	
						        <div class="pager">
								<el-row>
								<el-col :span="11" >	
									<el-pagination background layout="total,prev, pager, next" :pager-count="11"  :total="lineNum" :page-size="pageNum" :current-page="currentPage" @current-change="onPageChange">
									</el-pagination>
								</el-col?>	
						         <el-col :span="12" justify="center" v-if="repeatType==1"  id="qc-box">
					
								  <el-button v-on:click="repeatRemoveAll()" size="small" type="primary" plain>一键去重</el-button>
								  <el-button  v-on:click="repeatCancel()" size="small" type="primary" plain>返回</el-button>
						        </el-col>
						        <div v-if="repeatType==2"  id="qc-box">
									 <el-button v-on:click="repeatKeepOne()" size="small" type="primary" plain>随机去重</el-button>
									 <el-button v-on:click="repeatConfirm()" size="small" type="primary" plain>确认</el-button>
									 <el-button v-on:click="repeatCancel()" size="small" type="primary" plain>返回</el-button>
						       </div> 
							   </el-row>
							    
							 
		<el-row>					   
	
		</el-row>
		
						        </div>
						    </td>
						</tr>
						
					</tbody>
	            </table>
	        
	            </div>
	
	         

		</el-col>
	</el-row>
	
	
	
	
	 <!--div class="modal fade" style="display: none;" id="search-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
	   <div class="modal-dialog" role="document">
	     <div class="modal-content">
	       <div class="modal-header">
	         <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
	         <div class="search-help" title="查找说明">?</div>
	         <h4 class="modal-title" id="myModalLabel">查找</h4>
	       </div>
	       <div class="modal-body clearfix">
	            <div class="col-md-8">
	                <form>
	                <div class="form-group">
	                    <h5>查找内容（N）：</h5>
	                    <input type="text" name="" class="form-control">
	                </div>
	                <div class="form-group">
	                    <h5>替换为(N):</h5>
	                    <input type="text" name="" class="form-control">
	                </div>
	                <div class="checkbox">
	                    <label><input type="checkbox" value="">区分大小写(C)</label>
	                </div>
	                <div class="checkbox">
	                    <label><input type="checkbox" value="">全字匹配(W)</label>
	                </div>
	                <div class="checkbox">
	                    <label><input type="checkbox" value="">区分全/半角(M)</label>
	                </div>
	                </form>
	            </div>
	            <div class="col-md-4">
	                <button type="button" class="btn btn-default">查找下一个(F)</button>
	                <button type="button" class="btn btn-default">关闭</button>
	                <button type="button" class="btn btn-default">替换(R)</button>
	                <button type="button" class="btn btn-default">全部替换(A)</button>
	            </div>
	     </div>
	</div>
	
	       </div>
	 </div-->
	
</div>
</el-main>
</div>
</template>

<script>

export default {
	data() {
		return {
			//url:"http://127.0.0.1:8089",
			url:"https://paas.lscat.cn",
			//urlPython:"http://127.0.0.1:8000",
			urlPython:"https://www.lscator.com:8000",
			urlUpload:"#",
			tokenUpload:{},
			editMode:0,

			autoSave:1,
			info:{
					
			},
			nodes:{
				origin:[],
				translate:[]
			},
			uploadType:1,
			fileType:'normal',
			fileList:  [],
			lastModify:'',
			repeatType:0,
			lineNum:0,
			pageNum:50,
			currentPage:1,
			watchOrigin:1,
			watchTranslate:1,
			lang:[ 
				{code : "zh", title : "中文"},
				{code : "cs", title : "捷克语"},
				{code : "da", title : "丹麦语"},
				{code : "nl", title : "荷兰语"},
				{code : "en", title : "英语"},
				{code : "et", title : "爱沙尼亚语"},
				{code : "fi", title : "芬兰"},
				{code : "fr", title : "法语"},
				{code : "de", title : "德语"},
				{code : "it", title : "意大利语"},
				{code : "nb", title : "挪威语"},
				{code : "pl", title : "波兰语"},
				{code : "pt", title : "葡萄牙语"},
				{code : "sl", title : "斯洛文尼亚语"},
				{code : "es", title : "西班牙语"},
				{code : "sv", title : "瑞典语"},
				{code : "tr", title : "土耳其语"},
				{code : "ja", title : "日语"},
			],
			title:'',
			selectLang:{          
				origin:'zh',
				translate:'en'
			},
			repeatTemp:{},
			repeatLine:[],
			recordTemp:{
				info:[],
				lineNum:[],
				k:0,
				step:0
			}
			
		}
  },
  created: async function(){
		
		document.title='LSCAT语料对齐';
		if(this.$route.query.id){
            
			this.id = this.$route.query.id;
            
			var data={};
			data.id=this.id;

			const result = await this.post(this.url+"/corpus/public/get-tmx-data",{"Content-Type":"application/x-www-form-urlencoded"},this.getFrom(data));
			if(result){
				if(result.error){
					alert(result.message);
					 return;
				}
				
				var data=result.content;
				if(!data) return;
				     
				this.info.translate=data.translate;
				this.info.origin=data.origin;
				this.info.title=data.title;
				this.renewLineNum();
			}
                
			
		}else if(localStorage.getItem('info')){
			
			   this.$confirm('检测到您'+localStorage.getItem('updateAt')+'编辑的文件，是否继续编辑？', '确认信息', {
			          distinguishCancelAndClose: true,
			          confirmButtonText: '继续编辑',
			          cancelButtonText: '放弃编辑'
			        })
			          .then(() => {
						  
						  
						  this.info = JSON.parse(localStorage.getItem('info'));
						  this.lastModify= localStorage.getItem('updateAt');
						  this.lastFileName=localStorage.getItem('lastfile');
						  this.lastOrignfileName=localStorage.getItem('lastOrignfileName');
						  this.lastTransFileName=localStorage.getItem('lastTransFileName');
						  this.renewLineNum();      
			            this.$message({
			              type: 'info',
			              message: '继续编辑'
			            });
			          })
			          .catch(action => {
						localStorage.clear();
			            this.$message({
			              type: 'info',
			              message: '放弃编辑'
			            })
			          });
			      
		            
		}
		            

  },
  watch:{
	    'info.origin.content': function (val, oldVal) {
			
			if(this.watchOrigin==1){
				this.debounce(this.recordInfo);
			}else{
				this.watchOrigin=1;
			}
	       
	      },
		
		'info.translate.content': function (val, oldVal) {
			
		    if(this.watchTranslate==1){
		    	this.debounce(this.recordInfo);
		    }else{
		    	this.watchTranslate=1;
		    }
		    	       
		   }
		 
	  
  },
  methods:{
	 

	handleBefore:async function(file,event) {
		
		this.loading = this.$loading({
		          lock: true,
		          text: 'Loading',
		        });
		const token =  await this.getUploadToken();
		
	    return new Promise((resolve, reject) => {
	          this.$nextTick(() => {
	          this.urlUpload =token.url;
			  this.tokenUpload ={'token':token.token};
			  resolve();
	          })
	
	        })
		},
		
	getUploadToken: async function(){
		
		//const result= await fetch(this.urlPython+"/get-token").then(r=>r.json());
		const result=await this.get(this.urlPython+"/get-token");
		
		return result;
	},
	changeUploadType: function(type='normal'){
		this.fileType=type;
		
		
	},
	handleSuccess: async function(response, file, fileList) {
		var data={};
		//data:{'key':this.file.name,'originLang':this.file.originLang,'translateLang':this.file.translateLang,'type':this.uploadType}
		data.key=response.key;
		
		if(this.fileType=='normal'){
			data.originLang=this.selectLang.origin;
			data.translateLang=this.selectLang.translate;
		}else if(this.fileType=='origin'){
			data.originLang=this.selectLang.origin;
		}else{
			data.translateLang=this.selectLang.translate;
		}
		data.type=this.uploadType;
		const result = await this.post(this.urlPython+"/do",{"Content-Type":"application/json;charset=UTF-8"},JSON.stringify(data));
		
		if(result){
			var newData={};
			if(this.fileType=='normal'){
				newData=result;
				//this.$set(this,'info',result);
			}else if(this.fileType=='origin'){
				
				newData.origin=result.origin;
				newData.translate=this.info.translate==undefined? result.translate:this.info.translate;
				newData.lineList=this.info.lineList==undefined? result.lineList:this.info.lineList;
			
			}else{
				
				newData.translate=result.translate;
				newData.origin=this.info.origin==undefined? result.origin:this.info.origin;
				newData.lineList=this.info.lineList==undefined? result.lineList:this.info.lineList;


			}
		
			this.$set(this,'info',newData);
		
			this.renewLineNum();
			this.loading.close();
		}

	      },

	editorClick: function(index,n,event){
		
				if(this.editMode==0) return;
              	//编辑器
              	if(event.target.nodeName=='TEXTAREA') {
              			
              			this.lastFocused.target=event.target;
              			this.lastFocused.index=index;
              			this.lastFocused.n=n;
              	   
              			return;
              		}
              
              	
              	//多选
              	if(event.shiftKey) {
					
				  if(n=='b'){
				  	
				    this.nodes['origin'][index]=[];
				    this.nodes['origin'][index]['clicked'] =1;
				 
					var keys =Object.keys(this.nodes['origin']);
					var begin = parseInt(keys.shift());
					var end = parseInt(keys.pop());
					this.nodes=[];
					this.nodes['origin']=[];
					this.nodes['translate']=[];
									   
						for(var i=begin;i<=end;i++){
											
							this.nodes['origin'][i]=[];
							this.nodes['origin'][i]['clicked'] =1;
							this.nodes['translate'][i]=[];
							this.nodes['translate'][i]['clicked'] =1;			   
						}
				  	      	         
				  }else{
					  
				  	this.nodes[n][index]=[];
				  	this.nodes[n][index]['clicked'] =1;
				  	  
				  	var keys =Object.keys(this.nodes[n]);
				  	var begin = parseInt(keys.shift());
				  	var end = parseInt(keys.pop());
				  	this.nodes=[];
				  	this.nodes['origin']=[];
				  	this.nodes['translate']=[];
				  	  	   	       
				  	for(var i=begin;i<=end;i++){
				  	      	        	
				  	    this.nodes[n][i]=[];
				  	    this.nodes[n][i]['clicked'] =1;
				  	      	        	   
				  	}
				  	      	         
				  }
				              
				  
				  
      	         
      	           return;
          		}
			
				 //选取特定行
				 if(event.ctrlKey||event.metaKey) {
				 
				   if(n=='b'){
					
					 this.nodes['origin'][index]=[];
					 this.nodes['origin'][index]['clicked'] =1;
				  
					var keys =Object.keys(this.nodes['origin']);
				 
					this.nodes=[];
					this.nodes['origin']=[];
					this.nodes['translate']=[];
					for(var k in keys){
										
					   this.nodes['origin'][keys[k]]=[];
					   this.nodes['origin'][keys[k]]['clicked'] =1;
					   this.nodes['translate'][keys[k]]=[];
					   this.nodes['translate'][keys[k]]['clicked'] =1;	
										   
					}
										   
					
									 
				   }else{
					console.log(this.nodes[n]);
					this.nodes[n][index]=[];
					this.nodes[n][index]['clicked'] =1;
					var keys =Object.keys(this.nodes[n]);
					
					this.nodes=[];
					this.nodes['origin']=[];
					this.nodes['translate']=[];
								   
					for(var k in keys){
										
						this.nodes[n][keys[k]]=[];
						this.nodes[n][keys[k]]['clicked'] =1;
										   
					}
											 
				   }
				  
					return;
				 }
								
              	this.nodes=[];
  	            this.nodes['origin']=[];
  	            this.nodes['translate']=[];
  	            this.lastFocused={};
              	
              	if(n=='b'){
              		
              	    this.nodes['origin'][index]=[];
        	        this.nodes['origin'][index]['clicked'] =1;
        	        this.nodes['translate'][index]=[];
      	            this.nodes['translate'][index]['clicked'] =1;
              		
              	}else{
              		
              	    this.nodes[n][index]=[];
        	        this.nodes[n][index]['clicked'] =1;
					
              	}
            
             
        			return;
  },					 
    editorDbClick: function(index,n,event){
				if(this.editMode==0) return;
				var nodes={};
              	nodes['origin']=[];
  	            nodes['translate']=[];
				
  	            nodes[n][index]=[];
  	            nodes[n][index]['dbclicked'] =1;
				this.$set(this,'nodes',nodes);
				console.log(this.nodes);
  },
  textareaChange: function(event){
				this.$forceUpdate();
  },

	initLang: function(t){
          	   
          	   this.originLang=this.selectLang.origin;
          	   this.translateLang=this.selectLang.translate;
	},
    //更新数据   
    saveTmx: async function(){
				if(this.editMode==0) return;
             	if(this.id){
             	
             	 var info=JSON.stringify(this.info);
             	 
				 var data={};
				 data.id=this.id;
				 data.info=info;
				 const result = await this.post(this.url+"/corpus/public/save-tmx",{"Content-Type":"application/x-www-form-urlencoded"},this.getFrom(data));
				 this.$message.success('已保存');
             	}else if(this.task){
  	
  	      	 info=JSON.stringify(this.info);
             	 
             	 $http({
             		method: "POST",
             		headers: {
                	       'Content-Type': 'application/x-www-form-urlencoded'
                	     },
             	    url: this.url+"/corpus/public/save-tmx",
             	    data:$.param({'info':info,'task':this.task})
             	}).success(function(data){
  	
             		  	alert('保存成功');
  	        	 	return;
                  	  
            	        //window.location.href=data.url;
             	});
  	
  	
  			}else{
  				
  				 
             		alert('非编辑模式');
  	        	 return;
  				
  			}
             	 
                 
    },
       
    exportFile: async function(){
                 
				if(this.editMode==0) return;
             	if(this.info=={}) return;
				
				var data={};
				
				data.origin=this.info.origin.content;
				data.translate=this.info.translate.content;
				data.title=this.info.title;
				data.lineList=this.info.lineList;
				data.originLang=this.selectLang.origin;
				data.translateLang=this.selectLang.translate;
				const result = await this.post(this.urlPython+"/export-tmx",{"Content-Type":"application/json;charset=UTF-8"},JSON.stringify(data));
				
				if(result){
					window.location.href=result.path;
					this.$message.success('导出成功');
					
				}else{
					
					this.$message.error('导出失败');
				}
			
          
          
  },
    alignerLine: async function(){
              	
				if(this.editMode==0) return;
  				if(this.info.translate.line!==this.info.origin.line){
  					this.$message.error("请先将段落对齐");
  					return;
  				}
              	
				
				var data={};
				
				data.origin=this.info.origin.content;
				data.translate=this.info.translate.content;
				data.originLang=this.selectLang.origin;
				data.translateLang=this.selectLang.translate;
				data.lineList=this.info.lineList;
				const result = await this.post(this.urlPython+"/aligner",{"Content-Type":"application/json;charset=UTF-8"},JSON.stringify(data));
				
				if(result){
					this.info = result;
					this.renewLineNum()
					this.$message.success('已完成对齐');
					
				}else{
					
					this.$message.error('对齐失败');
				}
							
          
  },
	preProcessing: async function(){
              	
				if(this.editMode==0) return;

				
				var data={};
				
				data.origin=this.info.origin.content;
				data.translate=this.info.translate.content;
				data.originLang=this.selectLang.origin;
				data.translateLang=this.selectLang.translate;
				data.lineList=this.info.lineList;
				const result = await this.post(this.urlPython+"/pre-processing",{"Content-Type":"application/json;charset=UTF-8"},JSON.stringify(data));
				
				if(result){
					this.info = result;
					this.renewLineNum()
					this.$message.success('已完成预处理');
					
				}else{
					
					this.$message.error('预处理失败');
				}
							
          
  },
	countWords: async function(){
		
				if(this.editMode==0) return;
              	if(this.info==undefined) return;
  	
				var data={};
				
				data.origin=this.info.origin.content;
				data.translate=this.info.translate.content;
				data.originLang=this.selectLang.origin;
				data.translateLang=this.selectLang.translate;
				const result = await this.post(this.urlPython+"/count-tmx",{"Content-Type":"application/json;charset=UTF-8"},JSON.stringify(data));
				
				if(result){
					
					this.$message("原文字数"+result['origin']+",译文字数"+result['translate']+"");
				}
				
		
  },
    onPageChange: function (page) {
				this.currentPage = page;
				console.log(1);
                  this.renewLineNum();
  },
	back: function(){
		
              	if(this.editMode==0) return;
				
                if(this.recordTemp.step>1){
  	          	   var i=JSON.parse(JSON.stringify(this.recordTemp.info[this.recordTemp.step-2]));
  	        	   var n=JSON.parse(JSON.stringify(this.recordTemp.lineNum[this.recordTemp.step-2]));
				   this.$set(this,'info',i);
				   this.$set(this,'lineNum',n);
           	   	   this.recordTemp.step--;
					
				   this.watchOrigin=0;
				   this.watchTranslate=0;
  
                 }
  },
    forward: function(){
		
				if(this.editMode==0) return;
				if(this.recordTemp.k>this.recordTemp.step){
   	          	   var i=JSON.parse(JSON.stringify(this.recordTemp.info[this.recordTemp.step]));
  	        	   var n=JSON.parse(JSON.stringify(this.recordTemp.lineNum[this.recordTemp.step]));
               	 //  this.info = i;
           	   	 //  this.lineNum = n;
				   this.$set(this,'info',i);
				   this.$set(this,'lineNum',n);
  	     	   	   this.recordTemp.step++;
				   this.watchOrigin=0;
				   this.watchTranslate=0;
				     
  	        	}
  },
	mergeLine: function(){
		
				if(this.editMode==0) return;
              	for(var n in this.nodes){
              		
                  	
                  	if(this.nodes[n].length!==0){
                  		
            	       var keys =Object.keys(this.nodes[n]);
           	           var length=keys.length;
          	           var begin = parseInt(keys.shift());
          	           var content="";
                  		
                  		for(var i in this.nodes[n]){
                  		 
                  		   content=content+this.info[n].content[i];
                  	
                  		}  	
                  		 
  	        	           this.info[n].line= this.info[n].line-length+1;
                  		   this.info[n].content[begin]=content;
                 	       this.info[n].content.splice(begin+1,length-1);
                 	         
                  		   this.nodes[n]=[];
                  		   this.nodes[n][begin]=[];
               	           this.nodes[n][begin]['clicked'] =1;
                  		　　this.renewLineNum();
                  	}
    
             
                  	
              	}
              	
  
  },
    esplitLine: function(){
              	
				if(this.editMode==0) return;	
              	if(this.lastFocused.target==undefined) {
					this.$message.error('请先选中需切分的位置');
					 return;
				}
                  var textarea = this.lastFocused.target;
                  var index = this.lastFocused.index;
                  var n  =this.lastFocused.n;
                  var point =textarea.selectionStart;
              
                  if(n=='origin'){
              	  	 
					this.nodes['origin'][index]=[];
             		var content1 = this.info.origin.content[index].substring(0, point);
             		var content2 = this.info.origin.content[index].substring(point, this.info.origin.content[index].length);
             		this.info.origin.line+=1;
             		this.info.origin.content[index]=content1;
                 	this.info.origin.content.splice(this.nodes['origin'].length,'0',content2); 
                 	
                 	this.renewLineNum();
                 	 
  	            }else{
  	             this.nodes['translate'][index]=[];
				 var content1 = this.info.translate.content[index].substring(0, point);
  	             var content2 = this.info.translate.content[index].substring(point, this.info.translate.content[index].length);
  	           	 this.info.translate.line+=1;
  	             this.info.translate.content[index]=content1;
  	             this.info.translate.content.splice(this.nodes['translate'].length,'0',content2);  
  	             this.renewLineNum();
  	               	 
  	            }
                
	},
	moveUp: function(){
		
              	if(this.editMode==0) return;
              	for(var n in this.nodes){
              		
              		
                  	if(this.nodes[n].length!==0){
                  		
            	       var keys =Object.keys(this.nodes[n]);
					   //keys.reverse();
					   console.log(keys);
					   console.log( this.nodes[n]);
					  
						for(var k in keys){
							
							var key=parseInt(keys[k]);
								
							if(key>0){
          	           		   var content=this.info[n].content[key-1];
                     	       this.info[n].content.splice(key-1,1);
                     	       this.info[n].content.splice(key,0,content);
  
                     		   this.nodes[n][key-1]=[];
                  	           this.nodes[n][key-1]['clicked'] =1;
                  	        //   this.nodes[n].pop();
							   delete this.nodes[n][key];
							   
								}
							}
							this.renewLineNum();
						
				/*		
           	           var length=keys.length;
          	           var begin = parseInt(keys.shift());        
          	           var p=parseInt(keys.pop());
          	           var end = p?p:begin;
          	       
          	           	   if(begin>0){
          	           		   var content=this.info[n].content[begin-1];
                     	       this.info[n].content.splice(begin-1,1);
                     	       this.info[n].content.splice(end,0,content);
  
                     		   this.nodes[n][begin-1]=[];
                  	           this.nodes[n][begin-1]['clicked'] =1;
                  	           this.nodes[n].pop();
                  	        
                     		　　this.renewLineNum();
          	           	   }
                */  		
                  	}
    
             
                  	
              	}
	},
	moveDown: function(){
		
              	if(this.editMode==0) return;
              	for(var n in this.nodes){
              		
                  	if(this.nodes[n].length!==0){
                  	
            	       var keys =Object.keys(this.nodes[n]);
					   keys.reverse();
							for(var k in keys){
								var key=parseInt(keys[k]);
								
								if(key+1<this.info[n].line){
									var content=this.info[n].content[key+1];
								
									this.info[n].content.splice(key+1,1);
									this.info[n].content.splice(key,0,content);
									
									this.nodes[n][key+1]=[];
									this.nodes[n][key+1]['clicked'] =1;
									delete this.nodes[n][key];
								}
							}
							this.renewLineNum();
					/*	
           	           var length=keys.length;
          	           var begin = parseInt(keys.shift());        
          	           var p=parseInt(keys.pop());
          	           var end = p?p:begin;
						  console.log(this.info[n].line);
          	           	   if(end+1<this.info[n].line){
          	           		 
          	           		   var content=this.info[n].content[end+1];
                     	       this.info[n].content.splice(end+1,1);
                     	       this.info[n].content.splice(begin,0,content);
                     	         
                     		   this.nodes[n][end+1]=[];
                  	           this.nodes[n][end+1]['clicked'] =1;
                  	           delete this.nodes[n][begin];
           
                     		　　this.renewLineNum();
          	           	   }
                  	*/	
                  	}
    
             
                  	
              	}
  
	},
	//数组调换位置
    swapItems: function(arr, index1, index2){
              	　　arr[index1] = arr.splice(index2,1,arr[index1])[0];
              	　　return arr;
    },
	upRecord: function(arr, index) {
			if(index == 0) {
			  return;
			}
			return this.swapItems(arr, index, index - 1);
	},
	downRecord: function(arr, index) {
		
			if(index == arr.length -1) {
			  return;
			}
			console.log(arr.length -1);
			console.log(index);
			var result= this.swapItems(arr, index, index + 1);
			return result;
	},
	editorAdd: function(){
				
				if(this.editMode==0) return;
              	if(this.nodes['origin'].length!==0){
             
              		 var line = "";
              		 this.info.origin.line+=1;
                  	 this.info.origin.content.splice(this.nodes['origin'].length,'0',line);  
                  	 this.renewLineNum();
              	} 
              	if(this.nodes['translate'].length!==0){
              		
              		 var line = "";
              		 this.info.translate.line+=1;
              	 	 this.info.translate.content.splice(this.nodes['translate'].length,'0',line);  
                  	 this.renewLineNum(); 
              	}
              	
	},
	editorDelete: function(){
              	
				if(this.editMode==0) return;
				
              	for(var n in this.nodes){
              	
                  	if(this.nodes[n].length!==0){
                  		
           	           var keys =Object.keys(this.nodes[n]);
					   var i=0;
							for(var k in keys){
							
								var s=keys[k]-i;
								this.info[n].content.splice(s,1);
								this.info[n].line-=1;
								i++;
							
							}
						this.nodes[n]=[];
					  
					            	  
						if(this.repeatTemp[n]&&JSON.stringify(this.repeatTemp[n])!=="{}"){
							this.watchOrigin=0;
							this.watchTranslate=0; 
							var i=0;
							for(var k in keys){

								var s=this.repeatLine[keys[k]]-i;
								this.repeatTemp[n].splice(s,1);
								i++;
							
							}
						            
						
						}
          	         
                  	}
          
              	}
			
              	 this.renewLineNum();
              	 return;
	},        
    changeLine: function(){
              	
              	if(this.editMode==0) return;
              	for(var n in this.nodes){
              		
                  	
                  	if(this.nodes[n].length!==0){
                  	
                  	   var n_2=n=='origin'?'translate':'origin';
           	           var keys =Object.keys(this.nodes[n]);
           	           var length=keys.length;
           	           var begin = parseInt(keys.shift());
           	           
  	         	      for(var i in this.nodes[n]){
  	               		 
  	             		   var content=this.info[n_2].content[i];
  	             		 
						   this.$set(this.info[n_2].content,i,this.info[n].content[i]);
						   this.$set(this.info[n].content,i,content);

  	             		}  
           	           
           	          
                  	}
    
              	}
			
              	 this.renewLineNum();
              	 return;
              	
	},        
    changeAll: function(){
		
				if(this.editMode==0) return;
                var tcontent=this.info.origin.content;
              	this.info.origin.content=this.info.translate.content;
              	this.info.translate.content=tcontent;
    },
	removeAll: function(){
				
	
  		    	localStorage.clear();
  		    	window.location.href='';
    },
	switchMode: function(t){
                 
              	this.mode=this.mode=='single'?'double':'single';
              	this.uploadType=t;
    },
	repeatCancel: function(){
					
				if(this.editMode==0) return;
                  if(this.repeatTemp['origin']&&JSON.stringify(this.repeatTemp['origin'])!=="{}"){
					this.watchOrigin=0;
					this.watchTranslate=0; 
                  	this.info.origin.content=this.repeatTemp['origin'];
              		this.info.origin.line=this.repeatTemp['origin'].length;
              		this.info.translate.content=this.repeatTemp['translate'];
              		this.info.translate.line=this.repeatTemp['translate'].length;
                  	this.renewLineNum();
                  }
                  this.repeatTemp['origin']={};
                  this.repeatTemp['translate']={};
				  this.repeatLine=[];
                  this.repeatType=0;
             	 return;
    },
	repeatConfirm: function(){
  
				if(this.editMode==0) return;
      
            
                this.info.origin.content=this.repeatTemp['origin'];
              	this.info.origin.line=this.repeatTemp['origin'].length;
              	this.info.translate.content=this.repeatTemp['translate'];
              	this.info.translate.line=this.repeatTemp['translate'].length;
                this.renewLineNum();
  
                this.repeatTemp['origin']={};
                this.repeatTemp['translate']={};
                this.repeatLine=[];
                this.repeatType=0;
             	return;
    },
	repeatFindAll: function(type){
				
				if(this.editMode==0) return;
                  
                if(!this.repeatType==0) return;
                  
                
                var repeatContent=[],repeat=[];
				  
                if(this.info.origin.content.length!==0&&this.info.origin.content.length!==0){
                  	
                this.repeatType=type;
				
          		if(this.repeatType==1){	
          			
              		for(var k in this.info.origin.content){
                  		
              			
              			if(this.info.origin.content[k]==this.info.translate.content[k]){
  
              				repeatContent.push(this.info.origin.content[k]);
							this.repeatLine.push(k);
              						
              			}
              			
              		}
              		
              		if(repeatContent.length){
						this.watchOrigin=0;
						this.watchTranslate=0;  
              			this.repeatTemp['origin']=this.info.origin.content;
              			this.repeatTemp['translate']=this.info.translate.content;
              			
                  		this.info.origin.content=repeatContent;
                  		this.info.origin.line=repeatContent.length;
                  		this.info.translate.content=repeatContent;
                  		this.info.translate.line=repeatContent.length;
              		
              		}else{
              			
              			this.repeatType=0;
              		}
              
          			
          	}else if(this.repeatType==2){
          		
          		repeat=this.uniq(this.info.origin.content,3);
          		console.log(repeat);

      			this.repeatTemp['origin']=this.info.origin.content;
      			this.repeatTemp['translate']=this.info.translate.content;
      			repeatContent['origin']=[];
      			repeatContent['translate']=[];
              	for(var i in repeat){
              		
              		if(repeat[i].length>1){
              			
                  		for(k in repeat[i]){
                  		
                  			repeatContent['origin'].push(this.repeatTemp['origin'][repeat[i][k]]);
                  			repeatContent['translate'].push(this.repeatTemp['translate'][repeat[i][k]]);
                      		this.repeatLine.push(repeat[i][k]);
                  		}
                
              		}
              	}
			
              	if(repeatContent['origin'].length>0){
              		this.watchOrigin=0;
              		this.watchTranslate=0;  
              		this.info.origin.content=repeatContent['origin'];
              		this.info.translate.content=repeatContent['translate'];
                  	this.info.origin.line=this.info.origin.content.length;
                  	this.info.translate.line=this.info.translate.content.length;
       
              		
              	}else{
              		
          			this.repeatType=0;
          		}
              
          		
          	}
          	
          	 this.renewLineNum(2);
          	 return;
            	
           	
                  }
    },
    repeatRemoveAll: function(){
		
				if(this.editMode==0) return;
                  var repeat=[];
  
                  if(this.repeatTemp['origin']&&JSON.stringify(this.repeatTemp['origin'])!=="{}"){

                  	this.info.origin.content=this.repeatTemp['origin'];
              		this.info.origin.line=this.repeatTemp['origin'].length;
              		this.info.translate.content=this.repeatTemp['translate'];
              		this.info.translate.line=this.repeatTemp['translate'].length;
                  
                  }
                  
              		if(this.repeatType==1){	
              			
                  		for(var k in this.info.origin.content){
                      		
                  			
                  			if(this.info.origin.content[k]==this.info.translate.content[k]){
                  					
                  				repeat.push(k);
  
                  				
                  			}
                  			
                  		}
                  		
                  		var n=0;
                  	
              			for (var t in repeat){
              					
              						var s=repeat[t]-=n;
         
                  					this.info.origin.content.splice(s,1);
                      				this.info.translate.content.splice(s,1);	
                      				this.info.origin.line-=1;
                        	            this.info.translate.line-=1;
                        	            n++;
              				
              					
              			}
              			
              	}
                   this.repeatTemp['origin']={};
                   this.repeatTemp['translate']={};
				   this.repeatLine=[];
                   this.repeatType=0;
              	   this.renewLineNum();
              	   return;
              	
    },
	repeatKeepOne: function(){
				
				if(this.editMode==0) return;
                  var repeat=[];
                  
                  if(this.repeatTemp['origin']&&JSON.stringify(this.repeatTemp['origin'])!=="{}"){
                    this.watchOrigin=0;
                    this.watchTranslate=0;  
                  	this.info.origin.content=this.repeatTemp['origin'];
              		this.info.origin.line=this.repeatTemp['origin'].length;
              		this.info.translate.content=this.repeatTemp['translate'];
              		this.info.translate.line=this.repeatTemp['translate'].length;
                  
                  }
                  
                  if(this.repeatType==2){
         
              		repeat=this.uniq(this.info.origin.content,3);
              		console.log(repeat);
              		var n=0;
              		var t=[];
                  	for(var i in repeat){
                  		
                  		if(repeat[i].length>1){
                  			//保留一条
                  			repeat[i].splice(0,1);
                  		
                  			t=t.concat(repeat[i]);                        		
                      		}
                    
                  		}
                  	
                  	var t=this.arrSort(t);
                  	
          			for(var k in t){
          				console.log(t[k]);
              			var s=t[k]-n;
      					this.info.origin.content.splice(s,1);
          				this.info.translate.content.splice(s,1);	
          				n++;
            	  	
              		}
            
                  	
                  	this.info.origin.line=this.info.origin.content.length;
        	        this.info.translate.line=this.info.translate.content.length;
        	            
              	
                  	}
                  	
                   this.repeatTemp['origin']={};
                   this.repeatTemp['translate']={};
                   this.repeatLine=[];
                   this.repeatType=0;
              	 this.renewLineNum();
              	 return;
              	
    },

	renewLineNum: function(mode=1){
			
			if(this.info.origin==undefined) return;
			
       	       var lineNum=this.info.origin.line>this.info.translate.line?this.info.origin.line:this.info.translate.line;
			  
       	       this.info.lineList=[];
       	       this.pageCount = Math.ceil(lineNum/this.pageNum);
       	       this.lineNum =lineNum;
       	       for(var i=0;i<this.pageNum;i++){
       	    	   var k=(this.currentPage-1)*this.pageNum+i;
       	    	    if(k<lineNum){
       	    	    	
       	    	   	this.info.lineList.push(k);
       	    	 
       	    	    }
					
       	       
              }
			  
			  this.editMode=1;
       	       
       	    // this.recordInfo();
       	      
 
    },
	recordInfo: function(){
              	console.log('record');
              	//正常操作，记录
              	 if(this.recordTemp.k==this.recordTemp.step){
					
              		var i=JSON.parse(JSON.stringify(this.info));
					var n=JSON.parse(JSON.stringify(this.lineNum));
              		
              		this.recordTemp.info.push(i);
              		this.recordTemp.lineNum.push(n);
              		this.recordTemp.k++;
              		this.recordTemp.step++;	
					
              	 }else if(this.recordTemp.k>this.recordTemp.step){ 		//有回退操作
            
              		this.recordTemp.info.splice(this.recordTemp.step,this.recordTemp.k-this.recordTemp.step); 
				
              		var i=JSON.parse(JSON.stringify(this.info));
              		var n=JSON.parse(JSON.stringify(this.lineNum));
              		this.recordTemp.info.push(i);
              		this.recordTemp.lineNum.push(n);
                  	this.recordTemp.step++;
                  	this.recordTemp.k=this.recordTemp.step;
              	 }
				 
				//缓存数据
				if(this.autoSave==1){
				       	    	  
				    localStorage.setItem('info',JSON.stringify(this.info));
				 	localStorage.setItem('updateAt',this.getDate(new Date(),'yyyy-MM-dd hh:mm:ss'));
				 	
				 	localStorage.setItem('lastfile',this.fileName);
				    localStorage.setItem('lastOrignfileName',this.originFileName);
				    localStorage.setItem('lastTransFileName',this.transFileName);
				
				}
				 
					console.log(this.recordTemp);
    },
	arrSort: function (arr, r, return_key) {
              	
                  if (return_key == true) {
                      var key_array = [];
                      var key_init = 0;
                      each(arr, function () {
                          key_array.push(key_init);
                          key_init++;
                      });
                  }
                  var low = 0;
                  var high = arr.length - 1;
                  var tmp, j;
                  while (low < high) {
                      for (j = low; j < high; ++j)
                          if (arr[j] > arr[j + 1]) {
                              tmp = arr[j];
                              arr[j] = arr[j + 1];
                              arr[j + 1] = tmp;
                              if (return_key == true) {
                                  tmp_k = key_array[j];
                                  key_array[j] = key_array[j + 1];
                                  key_array[j + 1] = tmp_k;
                              }
                          }--high;
                      for (j = high; j > low; --j)
                          if (arr[j] < arr[j - 1]) {
                              tmp = arr[j];
                              arr[j] = arr[j - 1];
                              arr[j - 1] = tmp;
                              if (return_key == true) {
                                  tmp_k = key_array[j];
                                  key_array[j] = key_array[j - 1];
                                  key_array[j - 1] = tmp_k;
                              }
                          }++low;
                  }
                  if (return_key == true) {
                      arr = key_array;
                  }
                  if (r == true) {
                      var r_arr = [];
                      while ((tmp = arr.pop()) != null) {
                          r_arr.push(tmp);
                      }
                      arr = r_arr;
                  }
                  return arr;
    },
	each: function(o,func){
          		for(var i in o){
          			if(typeof(o[i])!='function'){
          				func(o[i],i);
          			}
          		}
          	},
	getDate: function(date,fmt){  
  	              var o = {   
  	                "M+" : date.getMonth()+1,                 //月份   
  	                "d+" : date.getDate(),                    //日   
  	                "h+" : date.getHours(),                   //小时   
  	                "m+" : date.getMinutes(),                 //分   
  	                "s+" : date.getSeconds(),                 //秒   
  	                "q+" : Math.floor((date.getMonth()+3)/3), //季度   
  	                "S"  : date.getMilliseconds()             //毫秒   
  	              };   
  	              if(/(y+)/.test(fmt))   
  	                fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));   
  	              for(var k in o)   
  	                if(new RegExp("("+ k +")").test(fmt))   
  	              fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
  	              return fmt;   
    },
	uniq: function(array,type=1){
              
              	var temp = {}; 
              	var	temp2={};
                  for(var i = 0; i < array.length; i++){
                      if(type==1){
                      	
                      	if(temp.indexOf(array[i]) == -1){
                              temp.push(array[i]);
                          }    	
                      	
                      }else if(type==2){
                      	
                      	if(temp.indexOf(array[i]) == -1){
                              temp.push(array[i]);
                          }else{
                          	
                          	temp.splice(temp.indexOf(array[i]),1);
                          } 
                      }else if(type==3){
  
                      	var temp={};
                       	for(var i in array){
                      		if(temp[array[i]]==undefined){
                      			
                      			temp[array[i]]=[parseInt(i)];
                      		}else{
                      			
                      			temp[array[i]].push(parseInt(i));
                      		}
                      	}
                      	
               
                      }
                  
                  }
                  return temp;
		},
		
	post: async function(url,header={"Content-Type":"application/x-www-form-urlencoded"},data){
			
			const result=await fetch(url,{
					"body":data,
					"headers":header,
					"method":"post",
				}).then(r=>r.json());
				
				return result;
	},
		
	get: async function(url,data={}){
			var url=url+'?'+this.getFrom(data);
			const result=await fetch(url,{
					"method":"get",
				}).then(r=>r.json());
			
				return result;
	},
	//参数处理
	getFrom: function (arr){
		var formData="";
		for(var i in arr){
			formData+=i+"="+encodeURIComponent(arr[i])+"&";
		}
		return formData.substr(0,formData.length-1);
	
	},		
	debounce:function (fun, delay = 300) {   //默认300毫秒
	         if (this.fun !== null) {
	                clearTimeout(this.fun);
	            }
	        this.fun = setTimeout(fun, delay);
	    }

	}
  
}
</script>

<style>
</style>
